require('../BoundedText/Font.js');
import { fabric } from 'fabric';
import { calculateFontXHeight } from './FontUtils.js';
import { processTextTransform } from './Transform/index.js';
import { toPathDataFixed } from './Path.js';
import { rotatePoints, getRotationMode, _normalizePath } from './Utils';
import { applyInnerText } from '../BoundedText/inner-text';

const defaultOptions = {
    lineHeight: 400,
    letterSpacing: 0,
    fontSize: 200,
    transparent: 'rgba(0,0,0,0)',
    stroke: 'transparent',
    fill: '#000',
    textAlignment: 'center',
    strokeWidth: 0
};

fabric.TextTransform = fabric.util.createClass(fabric.Group, {
    type: 'text-transform',
    cacheProperties: fabric.Group.prototype.cacheProperties.concat(
        'text',
        'prefix',
        'betweenCharacters',
        'betweenWords',
        'fillPattern',
        'fontLibraryId',
        'strokeWidth',
        'stroke'
    ),

    editMode: false,
    version: '4.0.0',
    singleline: true,
    uppercase: false,
    betweenCharacters: '',
    betweenWords: '',
    fontSize: 200,
    letterSpacing: 0,
    variation: null,
    textAlignment: 'center',
    useLigatures: false,
    lineHeight: 1,
    angle: 0,
    text: '',
    _spaces: [],
    pathText: null,
    CACHE_FONT_SIZE: 200,
    _paths: null,
    __outPaths: null,
    texture: null,
    textureScale: 0,
    outlineWidth: 0,
    outline: '',
    transformOptions: {
        type: null
    },
    inPathEditMode: false,
    groupId: null,
    pageEpsId: null,
    minSizePx: 200,
    maxSizePx: 200,
    editedSize: false,
    needUpdatePreview: false,
    boundingRect: null,
    fontLibraryId: null,
    isTextPath: true,
    isSelectedGroup: false,

    /* stroke properties */
    stroke: 'transparent',
    strokeWidth: 0,
    strokeColorOption: 1,
    strokeColorLibraryId: null,
    strokeColorsMap: new Map(),
    strokeUniform: true,

    initialize(options, callback = null) {
        options = {
            ...options,
            id: options.id,
            strokeDashArray: options.strokeDashArray || [0, 0],
            originX: 'left',
            originY: 'top',
            zIndex: options.zIndex || 0,
            width: options.width || 0,
            height: options.height || 0,
            top: options.top || 0,
            left: options.left || 0,
            centeredRotation: true,
            angle: options.angle || options.rotation || 0,
            flipX: options.flipX || false,
            flipY: options.flipY || false,
            scaleX: options.scaleX || 1,
            scaleY: options.scaleY || 1,
            fontSize: options.fontSize || defaultOptions.fontSize,
            minSizePx: options.minSizePx || defaultOptions.fontSize,
            maxSizePx: options.maxSizePx || defaultOptions.fontSize,
            letterSpacing: options.letterSpacing || defaultOptions.letterSpacing,
            textAlignment: options.textAlignment || defaultOptions.textAlignment,
            lineHeight: options.lineHeight || defaultOptions.lineHeight,
            transparent: options.transparent || defaultOptions.transparent,
            uppercase: options.uppercase || options.caps || false,
            useLigatures: false,
            visibility: options.visibility || true,
            fontFamily: options.fontFamily || 'Arial_Regular',
            singleline: options.singleline || true,

            lockSkewingX: true,
            lockSkewingY: true,

            /* stroke properties */
            stroke: options.stroke || defaultOptions.stroke,
            strokeWidth: options.strokeWidth || defaultOptions.strokeWidth,
            strokeUniform: true,
            strokeColorOption: options.strokeColorOption || 1,
            strokeColorLibraryId: options.strokeColorLibraryId || null,
            strokeColorsMap: options.strokeColorsMap || new Map(),

            /* transform options */
            transformOptions: {
                type: null,
                points: [],
                ...options.transformOptions
            },
            fill: options.fill || defaultOptions.fill,
            variation: options.variation || null,
            verticalAlignment: options.verticalAlignment || 'top',
            editMode: options.editMode || false,
            name: options.name || 'Warped Text',
            text: options.text || 'TEXT'
        };

        this.callSuper('initialize', [], options, true);
        this._paths = null;

        this.pathText = new fabric.Path('', {
            id: options.id + '_text',
            fill: 'transparent',
            stroke: options.stroke || 'transparent',
            strokeWidth: options.strokeWidth || 0,
            strokeUniform: true,
            objectCaching: false,
            excludeFromExport: true
        });

        // Custom dimension handler
        this.pathText._finalizeDimensions = (x, y) => ({ x, y });

        this.fillRect = new fabric.Rect({
            excludeFromExport: true
        });

        this.pathMask = new fabric.PathMask('', {
            excludeFromExport: true
        });

        const strokeWidthDefault = 1;
        this.boundingRect = new fabric.Rect({
            left: 0,
            top: 0,
            width: 0,
            height: 0,
            fill: 'rgba(0, 0, 0, 0)',
            stroke: 'rgba(0, 0, 0, 0.3)',
            strokeWidth: strokeWidthDefault,
            strokeDashArray: options.strokeDashArray || [1, 1],
            selectable: false,
            evented: false,
            originX: 'center',
            originY: 'center',
            id: options.id + '_boundingRect',
            excludeFromExport: true
        });

        this.points = options.transformOptions.points || [];

        this.setControlsVisibility({
            mr: false,
            ml: false,
            mb: false,
            mt: false
        });

        this._setupEventHandlers();

        this.updatePathText({
            callback: (error) => {
                if (error) {
                    console.warn('Error updating text', error);
                    // if (callback) callback(null, error);
                    // return;
                }
                this._updateClipPath();
                this.addWithUpdate(this.pathText);
                this.addWithUpdate(this.boundingRect);

                options.width && this.set('width', options.width);
                options.height && this.set('height', options.height);
                options.stroke && this.set('stroke', options.stroke);
                options.strokeWidth && this.set('strokeWidth', options.strokeWidth);

                this.previousStrokeWidth = this.strokeWidth;

                // Calcula la posición central
                const { centerX, centerY } = this._calculateCenter();

                // Establece la posición inicial
                const initialTop = typeof options.top === 'number' ? options.top : centerY - this.height / 2;
                const initialLeft = typeof options.left === 'number' ? options.left : centerX - this.width / 2;

                // Actualiza la posición
                this.set('top', initialTop);
                this.set('left', initialLeft);

                // Aplica transformaciones iniciales
                if (options.scaleX) this.set('scaleX', options.scaleX);
                if (options.scaleY) this.set('scaleY', options.scaleY);
                if (options.flipX) this.set('flipX', options.flipX);
                if (options.flipY) this.set('flipY', options.flipY);
                if (options.angle) this.set('angle', options.angle);

                this.updatePathText({
                    pathUnchanged: true,
                    callback: async (error) => {
                        if (error) {
                            if (callback) callback(null, error);
                            return;
                        }
                        this.updateFakeDashArray();
                        if (callback) callback(this);
                    }
                });
            }
        });
    },

    _setupEventHandlers() {
        this.on('scaling', function (event) {
            const corner = event?.transform?.corner || '';
            this.resetControls();
            if (['ml', 'mr'].includes(corner)) {
                this.width *= this.scaleX;
                this.scaleX = 1;
                this.updatePathText({ isScaling: true });
            }
        });
        this.on('scaled', function () {
            const { scale } = this.getTextScale();
            this.updateStrokeWidthOnScale(scale);
            this.updateLastStrokeWidth(true);
            this.handleOnScale();
            this.handleFlip();
            this.width = this.width * this.scaleX;
            this.setFontSize(this.fontSize * scale);
            this.resetControls();
            this.updateFakeDashArray();
            if (this?.editMode) {
                this.setEditedProp?.('fontSize', 'minSizePx', 'maxSizePx', 'transformOptions');
            }
        });
        this.on('moving', this?.handleOnMove);
        this.on('rotating', function (event) {
            const useTopLeft = getRotationMode(event);
            this.handleRotation?.(this, useTopLeft);
            this.updateLastAngle?.();
        });
        this.on('rotated', (event) => {
            const useTopLeft = getRotationMode(event);
            this.handleRotation?.(this, useTopLeft);
            this.updateLastAngle?.();
            this.resetControls();
            if (this?.editMode) {
                this.setEditedProp?.('angle', 'rotate', 'transformOptions');
            }
        });
        this.on('selected', function () {
            this.isSelectedGroup = false;
            if (!this.inPathEditMode) {
                this.resetControls();
            }
            if (this.group) {
                this.isSelectedGroup = true;
            }
        });
        this.on('deselected', function () {
            this.setEditMode(undefined);
            this.updateLastAngle?.();
            this.updateFakeDashArray?.();
            if (this.isSelectedGroup) {
                this.handleOnMove?.();
            }
            this.isSelectedGroup = false;
        });
        this.on('removed', function () {
            this.isSelectedGroup = false;
            this.inPathEditMode = false;
        });
    },

    _needsClipPath() {
        // Check if there's a stroke with non-zero width
        const hasStroke = this.stroke && this.strokeWidth > 0;

        return hasStroke;
    },

    _updateClipPath() {
        if (this._needsClipPath()) {
            // Apply clip path
            this.clipPath = this.pathMask;

            // Handle fill rectangle
            const firstObject = this._objects[0];
            const needsFillRect = this.fillRect && firstObject?.type !== 'rect';

            if (needsFillRect) {
                this.insertAt(this.fillRect, 0);
            }

            // Clear text fill when using clip path
            if (this.pathText) {
                this.pathText.set('fill', null);
            }
            return;
        }
        // Remove clip path
        delete this.clipPath;

        // Remove fill rectangle
        this.remove(this.fillRect);

        // Restore text fill color
        if (this.pathText) {
            this.pathText.set('fill', this.fill);
        }
    },

    /*
     * Calculate object bounding box dimensions from its properties scale, skew.
     * @param Number width width of the bbox
     * @param Number height height of the bbox
     * @private
     * @return {Object} .x finalized width dimension
     * @return {Object} .y finalized height dimension
     */
    _finalizeDimensions: (x, y) => ({
        x: x,
        y: y
    }),

    /**
     * Sets specified property to a specified value
     * @param {String} key
     * @param {*} value
     * @chainable
     */
    _set(key, value) {
        if (key === 'fill' && value) {
            if (typeof value === 'object') {
                const objColor = fabric.util.createColorType(value);
                value = objColor ? objColor : value;
            }
        }
        this.callSuper('_set', key, value);
        if (key === 'fontFamily') {
            this.setFontFamily(value);
        } else if (key === 'text' || key === 'prefix' || key === 'suffix' || key === 'betweenCharacters' || key === 'betweenWords') {
            this.updatePathText();
        } else if (key === 'fill' && this.pathText && value) {
            this.fillRect.set(key, value);
            // fillRect only paints while the pathMask is the applied clip path; _needsClipPath() can say
            //  true well before that happens, as a stroke change never recalculates it
            if (this.clipPath !== this.pathMask) {
                this.pathText.set(key, value);
            }
            this.dirty = true;
        } else if (key === 'texture') {
            this.texture = value;
        } else if (key === 'top') {
            this.top = value;
        } else if (key === 'left') {
            this.left = value;
        } else if (key === 'caps') {
            this.uppercase = value;
        }

        // Handle stroke width property
        if (key === 'strokeWidth') {
            this._updateClipPath();
        }

        if (['stroke', 'strokeWidth'].includes(key) && this.pathText) {
            this.pathText.set(key, value);
            this.clipPath?.set(key, value);
            this.dirty = true;
            this.pathText.set('dirty', true);
        }
    },

    setFlip(value) {
        this.flipX = value;
        this.flipY = value;
        this.setCoords();
    },

    setFontFamily(family) {
        this.fontFamily = family;
        this.updatePathText();
    },

    getFontFamily() {
        return this.fontFamily;
    },

    setStrokeWidth(value) {
        this.set('strokeWidth', value);
        this.setCoords();
    },

    setBoundingStrokeWidth(value) {
        this.boundingRect.set('strokeWidth', value);
    },

    setMaxSizePx() {
        //
    },

    setMinSizePx() {
        //
    },

    setFontSize(size, options) {
        const { callback, isChanging } = options || {};

        // Reset scales
        this.scaleX = this.scaleY = 1;
        if (this.pathText) {
            this.pathText.scaleX = this.pathText.scaleY = 1;
        }

        this.updateLastScale();
        //this.set('fontSize', size);
        this.fontSize = size;
        this.minSizePx = size;
        this.maxSizePx = size;

        this.updatePathText({
            callback: () => {
                if (!isChanging) {
                    this._fireModified();
                }
                if (callback) callback();
            },
            isChanging
        });
    },

    setText(text) {
        this.set('text', text);
        this.updatePathText();
    },

    setColor(color) {
        this.set('fill', color);
    },

    getColor() {
        return this.fill;
    },

    getTextScale() {
        if (!this.pathText) {
            return { scaleX: 1, scaleY: 1, scale: 1 };
        }
        const { scaleX, scaleY } = this.pathText.getObjectScaling();
        return {
            scaleX,
            scaleY,
            scale: (scaleX + scaleY) / 2
        };
    },

    applyTextAlignment(layouts, targetWidth) {
        if (!layouts || !layouts.length) return [];

        return layouts.map((layout) => {
            // Clonar el layout para evitar modificar el original
            const processedLayout = { ...layout };
            const { width: lineWidth, glyphs } = processedLayout;

            let leftOffset = 0;
            let spaceBetween = 0;

            switch (this.textAlignment) {
                case 'center':
                    leftOffset = (targetWidth - lineWidth) / 2;
                    break;
                case 'right':
                    leftOffset = targetWidth - lineWidth;
                    break;
                case 'justify':
                    // Solo justificar si no es la última línea y el ancho es menor al objetivo
                    if (lineWidth < targetWidth && layout !== layouts[layouts.length - 1]) {
                        const gaps = glyphs.length - 1;
                        if (gaps > 0) {
                            spaceBetween = (targetWidth - lineWidth) / gaps;
                        }
                    }
                    break;
                default:
                    // 'left'
                    leftOffset = 0;
                    break;
            }

            // Aplicar offsets a los glifos
            if (glyphs && glyphs.length) {
                let currentX = leftOffset;

                processedLayout.glyphs = glyphs.map((glyph) => {
                    const processedGlyph = {
                        ...glyph,
                        x: currentX
                    };

                    // Actualizar posición x para el siguiente glifo
                    currentX += glyph.width + spaceBetween;

                    return processedGlyph;
                });
            }

            // Actualizar el ancho del layout si está justificado
            if (spaceBetween > 0) {
                processedLayout.width = targetWidth;
            }

            return processedLayout;
        });
    },

    getFontBounds(font, fontScale) {
        try {
            if (!font.tables.os2.sTypoDescender && !font.tables.os2.sTypoAscender) {
                const fontMetrics = {
                    minGlyphY: font.tables.os2.sTypoDescender * fontScale,
                    maxGlyphY: font.tables.os2.sTypoAscender * fontScale
                };
                return fontMetrics;
            }
            const glyps = [
                'g',
                'G',
                'a',
                'A',
                'o',
                'O',
                'Ñ',
                'Á',
                'É',
                'Í',
                'Ó',
                'Ú',
                'ñ',
                'á',
                'é',
                'í',
                'ó',
                'ú',
                '|'
            ];
            const glyphs = glyps.map((g) => font.charToGlyphIndex(g));
            let minGlyphY = 0;
            let maxGlyphY = 0;
            for (const glyphIndex of glyphs) {
                const glyph = font.glyphs.get(glyphIndex);
                if (glyph) {
                    const glyphBBox = glyph.getBoundingBox();
                    if (glyphBBox) {
                        minGlyphY = Math.min(minGlyphY, glyphBBox.y1 * fontScale);
                        maxGlyphY = Math.max(maxGlyphY, glyphBBox.y2 * fontScale);
                    }
                }
            }
            return {
                minGlyphY,
                maxGlyphY
            };
        } catch (error) {
            return {
                minGlyphY: 0,
                maxGlyphY: 0
            };
        }
    },

    getTextPaths(font, text, scale, singleLineOverride = false, refreshWidth = false) {
        const config = {
            text,
            singleline: singleLineOverride || this.singleline,
            width: this.width ? this.width * scale : undefined,
            fontSize: this.fontSize,
            letterSpacing: this.letterSpacing || 0,
            variation: this.variation,
            textAlignment: this.textAlignment,
            useLigatures: this.useLigatures,
            lineHeight: this.lineHeight,
            fixOrientation: false,
            refreshWidth,
            spaces: this._spaces
        };

        const unitsPerEm = font.unitsPerEm || 0;
        const fontScaleFactor = (config.letterSpacing * font.unitsPerEm) / 1000;
        const letterSpacingSelections = (config.letterSpacing * this.fontSize) / 1000;
        const lineHeight = (config.lineHeight * unitsPerEm) / 1000;

        const textLines = text.split('\n');

        let processedLines = textLines;

        // Text metrics storage
        const textMetrics = {
            text,
            textLines,
            _text: text.split(''),
            _textLines: [],
            _spaces: this._spaces || []
        };

        let fontScale = this.fontSize / unitsPerEm;
        const lineLayouts = processedLines.map((line, lineIndex) => {
            const yOffset = (this.fontSize + lineHeight * fontScale) * lineIndex;
            const glyphs = [];
            let position = 0;

            // Procesar cada carácter de la línea
            for (let i = 0; i < line.length; i++) {
                const char = line[i];
                const glyphIndex = font.charToGlyphIndex(char);
                let glyph = font.glyphs.get(glyphIndex);

                // Manejar ligaduras si están habilitadas
                let xAdvance = glyph.advanceWidth;
                if (this.useLigatures && i < line.length - 1) {
                    // Buscar posibles ligaduras
                    const nextChar = line[i + 1];
                    const ligatureGlyph = font.getGlyphByName(
                        font.substitution.lookup([glyph, font.charToGlyphIndex(nextChar)])
                    );
                    if (ligatureGlyph) {
                        glyph = ligatureGlyph;
                        xAdvance = ligatureGlyph.advanceWidth;
                        i++; // Saltar el siguiente carácter ya que forma parte de la ligadura
                    }
                }

                const glyphData = {
                    glyph,
                    x: position * fontScale,
                    y: yOffset,
                    width: xAdvance * fontScale
                };

                glyphs.push(glyphData);
                position += xAdvance + fontScaleFactor;
            }

            return {
                width: position * fontScale,
                glyphs
            };
        });

        // Handle line breaks and width constraints
        let finalLayouts = lineLayouts;

        // Calculate final width
        const targetWidth =
            config.singleline || config.width === undefined
                ? Math.max(...lineLayouts.map((line) => line.width))
                : config.width;

        // Apply text alignment and spacing
        const alignedLayouts = this.applyTextAlignment(finalLayouts, targetWidth);

        let initialOffsetX;
        let minGlyphY = 0;
        let maxGlyphY = 0;
        let maxGlyphX = 0;
        let minBoundsX = 0;
        let minBoundsY = 0;
        let maxBoundsX = 0;
        let maxBoundsY = 0;

        const paths = [];
        const charBounds = [];
        const characters = [];

        alignedLayouts.forEach((layout) => {
            const glyphPaths = layout.glyphs.map((glyphData) => {
                const { glyph, x, y } = glyphData;

                // En opentype.js usamos getBoundingBox() en lugar de cbox/bbox
                const glyphBBox = glyph.getBoundingBox();

                const xOffset = x / fontScale;
                const textAlignment = this.textAlignment || 'left';
                let alignmentOffset = 0;

                if (textAlignment === 'center') {
                    alignmentOffset = glyphBBox.x1 * fontScale;
                } else if (textAlignment === 'right') {
                    alignmentOffset = glyphBBox.x1 * fontScale * 2;
                }

                const left = x + alignmentOffset;
                const right = left + (glyphBBox.x2 - glyphBBox.x1) * fontScale;
                // En opentype.js las métricas están en tables.os2 y tables.hhea
                const topBearing = font.tables.os2.sTypoAscender ? font.tables.os2.sTypoAscender * fontScale : 0;
                const advanceHeight = font.tables.hhea.ascender * fontScale;
                const top = glyphBBox.y1 * fontScale;
                const bottom = glyphBBox.y2 * fontScale;
                const height = (glyphBBox.y2 - glyphBBox.y1) * fontScale;
                const width = (glyphBBox.x2 - glyphBBox.x1) * fontScale;
                const ascent = font.tables.os2.sTypoAscender * fontScale;
                const descent = font.tables.os2.sTypoDescender * fontScale;
                const capHeight = font.tables.os2.sCapHeight * fontScale;

                if (initialOffsetX === undefined) {
                    initialOffsetX = (glyphBBox.x1 + xOffset) * fontScale;
                    minBoundsX = left;
                }

                minBoundsX = Math.min(minBoundsX, left);
                maxBoundsX = Math.max(maxBoundsX, right);
                minBoundsY = Math.min(minBoundsY, top);
                maxBoundsY = Math.max(maxBoundsY, bottom);

                initialOffsetX = Math.min(initialOffsetX, (glyphBBox.x1 + xOffset) * fontScale);
                minGlyphY = Math.min(minGlyphY, glyphBBox.y1 * fontScale - glyphData.y);
                maxGlyphX = Math.max(maxGlyphX, (glyphBBox.x2 + xOffset) * fontScale);
                maxGlyphY = Math.max(maxGlyphY, glyphBBox.y2 * fontScale - glyphData.y);

                // En opentype.js, getPath() genera el path y toPathData() lo convierte a SVG
                // En lugar de toPathData(), usamos toPathDataFixed() para evitar notación científica
                const opentypePath = glyph.getPath(x, y, this.fontSize);
                const path = toPathDataFixed(opentypePath);

                return {
                    path,
                    lineHeight,
                    charBounds: {
                        top,
                        right,
                        left,
                        width,
                        minY: minBoundsY,
                        maxY: maxBoundsY,
                        height,
                        capHeight,
                        topBearing,
                        ascent,
                        descent,
                        advanceHeight,
                        kernedWidth: right - left,
                        advanceWidth: glyph.advanceWidth * fontScale,
                        deltaY: y
                    },
                    // En opentype.js, usamos unicode en lugar de codePoints
                    character: String.fromCharCode(glyph.unicode)
                };
            });

            const pathData = glyphPaths.map((glyph) => glyph.path);
            const charBoundsData = glyphPaths.map((glyph) => glyph.charBounds);
            const charactersData = glyphPaths.map((glyph) => glyph.character);

            paths.push(...pathData);
            charBounds.push(charBoundsData);
            characters.push(charactersData);
        });

        // Update text metrics
        textMetrics._textLines = characters;
        textMetrics.text = characters.flat().join('');
        textMetrics._text = textMetrics.text.split('');

        return {
            paths,
            bounds: {
                minX: initialOffsetX || 0,
                maxX: maxGlyphX,
                minY: minGlyphY,
                maxY: maxGlyphY
            },
            textProps: textMetrics,
            __charBounds: charBounds,
            targetWidth,
            numberOfLines: finalLayouts.length,
            letterSpacingSelections: letterSpacingSelections
        };
    },

    getApplyTransformOptions() {
        return {
            flipX: !!this.flipX,
            flipY: !!this.flipY,
            bounds: this._bounds,
            textAlignment: this.textAlignment,
            xHeight: this.xHeight * this.fontSize
        };
    },

    getAbsoluteTopLeftPoint() {
        const obj = this.getAbsoluteTopLeft();
        return new fabric.Point(obj.left, obj.top);
    },

    getAbsoluteCenterPoint() {
        const transformMatrix = this.calcTransformMatrix();
        return fabric.util.transformPoint(
            {
                x: 0,
                y: 0
            },
            transformMatrix
        );
    },

    getNeutralTransformOptions() {
        const neutralOptions = { ...this.transformOptions };

        if (neutralOptions.points) {
            const center = this.getAbsoluteCenterPoint();
            neutralOptions.points = rotatePoints(neutralOptions.points, center, this.angle, 0);
        }

        return neutralOptions;
    },

    updatePathText(options = {}) {
        let { callback, pathUnchanged = false, isScaling = false } = options;
        const fontFamily = this.fontFamily || '';
        if (!fontFamily) {
            if (callback) callback('Font family not set');
            return;
        }
        const font = Font.hasFont(fontFamily) ? Font.resolve(fontFamily) : false;
        if (!font) {
            if (callback) callback('Font not found');
            return;
        }
        const { scale } = this.getTextScale();
        if (scale !== 1) {
            this.scaleX = 1;
            this.scaleY = 1;
            this.pathText.scaleX = 1;
            this.pathText.scaleY = 1;
            this.updateLastScale();
            this.set('fontSize', this.fontSize * scale);
            pathUnchanged = false;
        }

        this.xHeight = calculateFontXHeight(font);

        if (!pathUnchanged || !this._paths) {
            let processedText = this.uppercase ? this.text.toUpperCase() : this.text;
            if (processedText) {
                processedText = applyInnerText(processedText, this.betweenCharacters, this.betweenWords);
                processedText = `${this.prefix || ''}${processedText}${this.suffix || ''}`;
            }

            const textPathsResult = this.getTextPaths(font, processedText, scale, false, isScaling);

            // Store path data
            this._paths = textPathsResult.paths;
            this._bounds = textPathsResult.bounds;
            this._numberOfLines = textPathsResult.numberOfLines;

            if (!this.singleline) {
                this.adjustableWidth = textPathsResult.targetWidth;
                this.width = textPathsResult.targetWidth;
            }
        }

        let finalPath = '';
        if (this.transformOptions.type && !this.isEditing) {
            // Obtener opciones de transformación
            const transformOptions = this.getApplyTransformOptions();
            const neutralOptions = this.getNeutralTransformOptions();

            // Procesar la transformación
            const { path, bounds, controlVector, outOfBounds } = processTextTransform(
                this._paths,
                neutralOptions,
                transformOptions
            );

            // Actualizar el estado
            finalPath = path;
            this.textOutOfBounds = !!outOfBounds;

            // Actualizar vectores de control y bounds si existen
            if (controlVector && bounds) {
                this._controlVector = controlVector;
                this._transformedBounds = bounds;
            } else {
                delete this._controlVector;
                delete this._transformedBounds;
            }
        } else {
            finalPath = this._paths.join('');
            delete this._controlVector;
            delete this._transformedBounds;
        }

        if (this.text?.trim() !== '') {
            this.translateToControlPoint?.();
        }
        this.updateLastAngle?.();
        this.setPath(finalPath);

        // Execute callback
        if (callback) callback();
    },

    updatePosition() {
        // Calculate dimensions based on transform state
        const dimensions =
            this.transformOptions.type && this._transformedBounds
                ? {
                      left: this._transformedBounds.minX,
                      top: -this._transformedBounds.minY,
                      width: this._transformedBounds.maxX - this._transformedBounds.minX,
                      height: this._transformedBounds.minY - this._transformedBounds.maxY
                  }
                : this.pathText._calcDimensions();

        // Get target width and handle text alignment
        const textWidth = this.width;
        const isMultilineWithWidth = !this.singleline && textWidth !== undefined;
        const widthDiff = textWidth - dimensions.width;

        // Calculate path offset based on text alignment
        const offsetX =
            this.textAlignment === 'left'
                ? textWidth / 2 + dimensions.left
                : this.textAlignment === 'right'
                ? textWidth / 2 + dimensions.left - widthDiff
                : dimensions.width / 2 + dimensions.left;

        // Set common properties for path elements
        const commonProps = {
            width: isMultilineWithWidth ? textWidth : dimensions.width,
            height: dimensions.height,
            pathOffset: new fabric.Point(
                isMultilineWithWidth ? offsetX : dimensions.width / 2 + dimensions.left,
                dimensions.height / 2 + dimensions.top
            ),
            dirty: true,
            originX: 'center',
            originY: 'center'
        };

        // Apply properties to main components
        this.pathText.set({ ...commonProps });
        this.pathMask.set({ ...commonProps });
    },

    _calcBounds(skipPosition) {
        const xCoords = [];
        const yCoords = [];
        const corners = ['tr', 'br', 'bl', 'tl'];

        if (this.pathText) {
            this.pathText.aCoords = this.pathText.calcACoords();
            corners.forEach((corner) => {
                xCoords.push(this.pathText.aCoords[corner].x);
                yCoords.push(this.pathText.aCoords[corner].y);
            });
        }

        this._getBounds(xCoords, yCoords, skipPosition);
    },

    _getBounds(xCoords, yCoords, skipPosition) {
        const minX = Math.min(...xCoords);
        const minY = Math.min(...yCoords);
        const maxX = Math.max(...xCoords);
        const maxY = Math.max(...yCoords);

        if (!minX || !minY || !maxX || !maxY) {
            return;
        }

        const topLeft = new fabric.Point(minX, minY);
        const bottomRight = new fabric.Point(maxX, maxY);

        const top = topLeft.y || 0;
        const left = topLeft.x || 0;

        const width = bottomRight.x - topLeft.x || 0;
        const height = bottomRight.y - topLeft.y || 0;

        this.width = width;

        if (this.text?.trim() !== '') {
            this.height = height;
        }

        if (!skipPosition && this.text?.trim() !== '') {
            this.setPositionByOrigin({ x: left, y: top }, 'left', 'top');
        }
    },

    setPath(pathData) {
        if (!this.pathText) {
            return;
        }
        this.__outPaths = pathData;
        let normalizedPath = '';
        try {
            normalizedPath = _normalizePath(pathData);
        } catch {
            // Ignore normalization errors and use an empty path
        }

        // Update the main text path
        this.pathText.set('path', normalizedPath);
        this.pathMask.set('path', normalizedPath);

        this.updatePosition();
        this._calcBounds(true);
        this.updateLastPos?.();
        this.updateLastFlip?.();
        this.updateLastAngle?.();
        this.updateLastScale?.();
        this._updateFillRect();
        this.updateFakeDashArray();

        [this.pathText, this.pathMask].forEach((obj) => {
            obj.dropPath2D?.();
            obj.updatePath2D?.();
        });

        if (this.canvas) {
            this.canvas.requestRenderAll();
        }
    },

    _calculateCenter() {
        if (this.canvas?.vptCoords?.tr && this.canvas?.vptCoords?.bl) {
            const { tr, bl } = this.canvas.vptCoords;
            return {
                centerX: (tr.x + bl.x) / 2,
                centerY: (bl.y + tr.y) / 2
            };
        }

        if (this.canvas?.getCenter) {
            const center = this.canvas.getCenter();
            return {
                centerX: center.left,
                centerY: center.top
            };
        }

        return {
            centerX: 0,
            centerY: 0
        };
    },

    _updateFillRect() {
        this.fillRect?.set({
            originX: 'center',
            originY: 'center',
            top: 0,
            left: 0,
            angle: 0,
            width: this.width,
            height: this.height,
            fill: this.fill,
            scaleX: 1,
            scaleY: 1
        });
    },

    updateStrokeWidthOnScale(scaleFactor) {
        this.set('strokeWidth', (this.lastStrokeWidth || this.strokeWidth) * scaleFactor);
    },

    updateFakeDashArray() {
        if (!this.boundingRect) return;
        const padding = 1;
        this.boundingRect.set({
            left: 0,
            top: 0,
            width: this.width + padding,
            height: this.height + padding,
            originX: 'center',
            originY: 'center'
        });
        this.boundingRect.dirty = true;
        this.canvas?.requestRenderAll();
    },

    getBoundingColor() {
        if (!this.boundingRect) return 'rgba(0, 0, 0, 0.3)';
        return this.boundingRect.stroke;
    },

    setBoundingColor(color) {
        if (!this.boundingRect) return;
        this.boundingRect.set('stroke', color);
        this.boundingRect.dirty = true;
    },

    getWidth() {
        return this.width * this.scaleX;
    },

    getHeight() {
        return this.height * this.scaleY;
    },

    getFontSize() {
        return this.fontSize;
    },

    getTextAlign() {
        return this.textAlignment;
    },

    setTextAlign(align) {
        this.set('textAlignment', align);
    },

    getTextVerticalAlign() {
        return this.verticalAlignment || 'top';
    },

    setTextVerticalAlign(align) {
        this.set('verticalAlignment', align);
    },

    getOutlineWidth() {
        return this.outlineWidth;
    },

    getTrackingAmount() {
        return this.letterSpacing;
    },

    getFlip() {
        return {
            flipX: this.flipX,
            flipY: this.flipY
        };
    },

    setOutlineColor() {
        //this.set('outline', color);
    },

    getOutlineColor() {
        return this.outline;
    },

    setAllowEdit(value) {
        this.allowEdit = value;
    },

    getText() {
        return this.text;
    },

    _fireModified() {
        const canvas = this.canvas;
        if (!canvas) {
            return;
        }
        canvas.fire('object:modified', {
            target: this
        });

        if (this?.editMode) {
            this.setEditedProp?.('transformOptions');
        }
    },

    setTransform(transformOptions, options = {}) {
        const { justEnabledFreeLineEdit, temporary = false, callback } = options;
        if (this.isEditing && !temporary) {
            this.exitEditing();
        }
        const isTypeChanged = this.transformOptions?.type !== transformOptions.type && !temporary;

        // Handle no transform type case
        if (!transformOptions.type && !temporary) {
            const centerPoint = this.getTextCenterPoint();
            this.setControlsVisibility({ mr: true, ml: true });
            this.width = this.adjustableWidth;
            this.setEditMode(undefined);
            this.set('transformOptions', transformOptions);
            this.resetControls();

            this.updatePathText({
                callback: () => {
                    this.adjustToCenter(centerPoint);
                    this._fireModified();
                    if (callback) callback();
                }
            });
            return;
        }

        if (isTypeChanged || justEnabledFreeLineEdit) {
            this.setControlsVisibility({ mr: false, ml: false });
            this.setEditMode(
                transformOptions,
                options?.sample
                    ? {
                          typeSample: options?.sample
                      }
                    : undefined
            );
            if (callback) callback();
            return;
        }

        if (!temporary) {
            this.set('transformOptions', transformOptions);
        }

        this.updatePathText({
            callback: () => {
                if (!transformOptions.isChanging) {
                    this._fireModified();
                }
                if (callback) callback();
            },
            isChanging: transformOptions.isChanging
        });
    },

    setTransformPoints(points, options = {}) {
        const { type, isChanging } = options;
        if (!this.inPathEditMode || (this.transformOptions && type !== this.transformOptions.type)) {
            return;
        }
        this.set('transformOptions', {
            ...this.transformOptions,
            points
        });

        this.updatePathText({
            callback: () => !isChanging && this._fireModified(),
            isChanging
        });
    },

    updateLastStrokeWidth(reset) {
        if (reset) {
            this.lastStrokeWidth = null;
            this.lastOutlineWidth = null;
            return;
        }

        this.lastStrokeWidth = this.lastStrokeWidth || this.strokeWidth;
        this.lastOutlineWidth = this.lastOutlineWidth || 0;
    },

    setCaps(caps) {
        this.uppercase = caps || false;
    },

    setOutlineWidth() {
        //this.set('outlineWidth', width);
    },

    setMultiline() {
        //
    },

    setVerticalText() {
        //
    },

    setCursorColor() {
        //
    },

    updateFromGroupScaling() {
        this.fire('scaled');
        this.setPositionByOrigin({ x: this.left, y: this.top }, 'left', 'top');
    },

    updateFromPreviewScaling() {
        const originalScaleX = this.originalWidth / this.width;
        const originalScaleY = this.originalHeight / this.height;
        this.scaleX = originalScaleX;
        this.scaleY = originalScaleY;
        this.set({
            scaleX: originalScaleX,
            scaleY: originalScaleY,
            top: this.originalTop,
            left: this.originalLeft
        });
        this.updateFromGroupScaling();
        this.fire('moving');
    },

    getStroke() {
        return this.stroke;
    },

    setStroke(color) {
        this.set('stroke', color);
    },

    setStrokeColor(color) {
        this.setStroke(color);
        this.strokeColor = color;
    },

    getStrokeWidth() {
        return this.strokeWidth;
    },

    getEditModeState() {
        return this.inPathEditMode || false;
    },

    setRotate(angle) {
        if (this.lockRotation) return;
        try {
            const transform = {
                action: 'rotate',
                original: fabric.util.saveObjectTransform(this),
                target: null
            };
            this.rotate(angle);
            transform.target = this;
            this.fire('rotated', {
                target: this,
                transform
            });
        } catch {
            console.warn('Error rotate');
        }
    },

    setTrackingAmount(amount) {
        this.set('letterSpacing', amount);
    },

    getPaths() {
        return new Promise((resolve) => {
            this.updatePathText({
                callback: () => {
                    resolve({
                        paths: [this.__outPaths],
                        bounds: this._bounds,
                        width: this.width,
                        height: this.height,
                        strokeWidth: this.strokeWidth,
                        fontSize: this.fontSize
                    });
                },
                returnPath: true
            });
        });
    },

    toSVG(options) {
        return [this.callSuper('toSVG', options)].join('');
    },

    clone: function (callback) {
        // Create a new TextTransform object. Cloning the object using the fabric.js
        //  utility clone() doesn't work well. This is the recommended way to clone
        //  groups.
        const copy = new fabric.TextTransform({
            width: this.getWidth(),
            height: this.getHeight(),
            originX: 'left',
            originY: 'top',
            left: this.left,
            top: this.top,
            skewX: this.skewX,
            skewY: this.skewY,
            strokeDashArray: this.strokeDashArray || [],
            angle: this.angle,
            centeredRotation: this.centeredRotation,

            lockSkewingX: this.lockSkewingX,
            lockSkewingY: this.lockSkewingY,
            lockScalingFlip: true,

            fontPath: this.fontPath,
            fontName: this.firstFontName || this.fontName,
            fontColorsMap: new Map(this.fontColorsMap),
            fontsMap: new Map(this.fontsMap),
            outlineColorsMap: new Map(this.outlineColorsMap),
            shadowColorsMap: new Map(this.shadowColorsMap),

            fontFamily: this.fontFamily || 'Arial_Regular',
            singleline: this.singleline || true,
            fontSize: this.fontSize,
            minSizePx: this.minSizePx,
            maxSizePx: this.maxSizePx,

            outlineColor: this.outlineColor,
            id: this.id,
            uuid: this.uuid,

            evented: this.evented,
            selectable: this.selectable,
            locked: this.locked,
            visible: this.visible,
            name: this.name,
            fontColorOption: this.fontColorOption,
            fontOption: this.fontOption,
            defaultValue: this.defaultValue,
            isPersonalizableText: this.isPersonalizableText,
            prefix: this.prefix,
            suffix: this.suffix,
            betweenCharacters: this.betweenCharacters,
            betweenWords: this.betweenWords,
            textAlign: this.textAlign,
            textVerticalAlign: this.textVerticalAlign,
            texture: this.texture,
            textureScale: this.textureScale,
            ligatures: this.ligatures,
            referenceId: this.referenceId,
            lineSpacing: this.lineSpacing,
            groupId: this.groupId,
            pageEpsId: this.pageEpsId,

            isTextPath: this.isTextPath,
            transformOptions:
                typeof this.transformOptions === 'object'
                    ? JSON.parse(JSON.stringify(this.transformOptions))
                    : this.transformOptions,

            /* stroke */
            stroke: this.stroke,
            strokeWidth: 0,
            strokeColorsMap: new Map(this.strokeColorsMap),
            strokeColorLibraryId: this.strokeColorLibraryId
        });

        copy.setMultiline(this.multiline);
        copy.setVerticalText(this.verticalText);
        copy.setFontFamily(this.getFontFamily());
        copy.setFontSize(this.fontSize);
        copy.setColor(this.getColor());
        copy.setStroke(this.stroke);
        copy.setStrokeColor(this.strokeColor ?? this.stroke);
        copy.setStrokeWidth(this.strokeWidth);
        copy.setCursorColor(this.cursorColor);
        copy.setTextAlign(this.textAlign);
        copy.setTextVerticalAlign(this.textVerticalAlign);
        copy.setOutlineColor(this.getOutlineColor());
        copy.setOutlineWidth(this.getOutlineWidth());
        copy.setTrackingAmount(this.getTrackingAmount());
        copy.set('caps', this.caps);
        copy.set('fontLibraryId', this.fontLibraryId);
        copy.set('colorLibraryId', this.colorLibraryId);
        copy.set('zIndex', this.zIndex);
        copy.set('version', this.version);
        copy.set('prefix', this.prefix);
        copy.set('suffix', this.suffix);
        copy.set('betweenCharacters', this.betweenCharacters);
        copy.set('betweenWords', this.betweenWords);
        copy.setFontSize(this.fontSize);
        copy.setAllowEdit(this.allowEdit);

        copy.set('text', this.getText());
        copy.inPathEditMode = false;
        copy.updatePathText();

        if (callback) {
            callback(copy);
        } else {
            return copy;
        }
    }
});
